import { ReservationFormValidator } from '@/modules/datalayer/ReservationForm'
import RodoAgreementsWFFMDataExchange from '@/services/RodoAgreementsWFFMDataExchange'
import RodoFormFieldsWFFMDataExchange from '@/services/RodoFormFieldsWFFMDataExchange'

import '@/stylesheets/modules/rodoBooking.scss'

class RodoBooking {
  constructor (bookingForm, rodoForm) {
    this.booking = bookingForm
    this.rodo = rodoForm

    this.booking.addEventListener('submit', this.submitBookingRodoForm.bind(this))
  }

  copyFormDataFromBookingFormToRodo () {
    const dx = new RodoFormFieldsWFFMDataExchange(this.rodo)

    const inputs = {
      firstName: this.booking.querySelector('#InformationFormName'),
      lastName: this.booking.querySelector('#InformationFormSurname'),
      email: this.booking.querySelector('#InformationFormEmail'),
      phone: this.booking.querySelector('#InformationFormNumber'),
    }

    const fieldsData = dx.data
    fieldsData[0].value = inputs.firstName.value
    fieldsData[1].value = inputs.lastName.value
    fieldsData[2].value = inputs.email.value
    fieldsData[3].value = inputs.phone.value
    dx.data = fieldsData
  }

  copyAgreementsFromBookingFormToRodo () {
    const dx = new RodoAgreementsWFFMDataExchange(this.rodo)
    const agreements = this.booking.querySelectorAll('.payment-agreement__content input[type="checkbox"]')
    const data = dx.data
    agreements.forEach((agreementField, index) => {
      data[index].selected = agreementField.checked
    })
    dx.data = data
  }

  submitBookingRodoForm () {
    if (new ReservationFormValidator(this.booking).isFormValid()) {
      log.debug('Copying over data from order form to rodo form')
      this.copyFormDataFromBookingFormToRodo()
      this.copyAgreementsFromBookingFormToRodo()
      log.debug('Submitting RODO form', this.rodo)
      this.rodo.submitWFFM()
    } else {
      log.debug('Form is not valid - it will not be submitted')
    }
  }
}

function getForms () {
  return {
    rodo: document.querySelector('.booking-rodo-form'),
    booking: document.querySelector('form[action^="/rezerwacja?"]'),
  }
}

export function init () {
  const { booking, rodo } = getForms()
  if (rodo && booking) {
    log.debug('Source form for managing booking RODO form found')
    new RodoBooking(booking, rodo)
  } else {
    log.debug('Either RODO form or BOOKING for not found - skipping')
  }
}



// WEBPACK FOOTER //
// ./src/modules/rodoBooking.js